const app = require("firebase");
// Required for side-effects
require("firebase/functions");
require("firebase/auth");
// import "firebase/auth";
// import "firebase/functions"
var firebaseConfig = {
  apiKey: "AIzaSyDh5KotaQHJrxEid_KV0uJ1_wsIETo8rf8",
  authDomain: "apnaq-prod.firebaseapp.com",
  databaseURL: "https://apnaq-prod.firebaseio.com",
  projectId: "apnaq-prod",
  storageBucket: "apnaq-prod.appspot.com",
  messagingSenderId: "478541703420",
  appId: "1:478541703420:web:8a1c2278020b91c6824f79",
  measurementId: "G-RK7L1X46GP"

};
class Firebase {
  constructor() {
    app.initializeApp(firebaseConfig);
    this.auth = app.auth();
    this.functions = app.functions();
  }
  /* forceRefresh */
  getIdToken = (history, gotIdToken) => {
    // console.log("firebase getIdToken called");
    this.auth.currentUser
      .getIdToken(true)
      .then(function (idToken) {
        // Send token to your backend via HTTPS
        // console.log("got id token");
        localStorage.setItem("idToken", idToken);
        // isUserAlreadyRegistered(idToken)
        // history.push("/dashboard");
        gotIdToken();

        return idToken;
        // ...
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  DoCreateUserWithPhoneNumber = (phone, verifier) =>
    this.auth.signInWithPhoneNumber(phone, verifier);

  doSignOut = () => this.auth.signOut();
}
export default Firebase;
